export type SupplyGroupStatusDto =
  | string
  | {
      code?: string;
      name?: string;
      label?: string;
      value?: string;
      tone?: string;
    };

export type SupplyGroupDto = {
  uuid: string;
  name: string;
  description: string | null;
  status: SupplyGroupStatusDto;
  enabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type SupplyGroupRequest = {
  name: string;
  description: string | null;
};

export type SupplyGroupListQuery = {
  name?: string;
  description?: string;
  enabled?: boolean;
  page?: number;
  size?: number;
  sort?: string;
};

export type SupplyGroupListResult = {
  items: SupplyGroupDto[];
  total: number;
};

export type SupplyGroupStatusLabel = 'Activo' | 'Inactivo';

export function supplyGroupStatusLabel(dto: SupplyGroupDto): SupplyGroupStatusLabel {
  const status = dto.status;
  if (status && typeof status === 'object') {
    if (status.tone === 'danger') return 'Inactivo';
    if (status.tone === 'success') return 'Activo';
    return classifyStatusName(status.name ?? status.label ?? status.code ?? '');
  }
  if (typeof status === 'string') {
    return classifyStatusName(status);
  }
  if (typeof dto.enabled === 'boolean') {
    return dto.enabled ? 'Activo' : 'Inactivo';
  }
  return 'Activo';
}

function classifyStatusName(raw: string): SupplyGroupStatusLabel {
  const normalized = raw.trim().toLowerCase();
  if (
    normalized === 'inactivo' ||
    normalized === 'inactive' ||
    normalized === 'disabled' ||
    normalized.startsWith('inactiv')
  ) {
    return 'Inactivo';
  }
  return 'Activo';
}
